"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _chunkOX4QNVYYjs = require('./chunk-OX4QNVYY.js');

var _jsxruntime = require('react/jsx-runtime');

var e = _chunkOX4QNVYYjs.c.call(void 0, {
  name: "CloseIconSmall",
  size: "Small",
  svg: _jsxruntime.jsx.call(void 0, "path", {
    d: "M11.0608 10.0002L14.2659 6.79506L14.9269 6.1341C15.0244 6.03659 15.0244 5.87815 14.9269 5.78065L14.2197 5.07344C14.1222 4.97594 13.9637 4.97594 13.8662 5.07344L10.0002 8.9395L6.1341 5.07313C6.03659 4.97562 5.87815 4.97562 5.78065 5.07313L5.07313 5.78034C4.97562 5.87784 4.97562 6.03628 5.07313 6.13379L8.9395 10.0002L5.07313 13.8662C4.97562 13.9637 4.97562 14.1222 5.07313 14.2197L5.78034 14.9269C5.87784 15.0244 6.03628 15.0244 6.13379 14.9269L10.0002 11.0608L13.2053 14.2659L13.8662 14.9269C13.9637 15.0244 14.1222 15.0244 14.2197 14.9269L14.9269 14.2197C15.0244 14.1222 15.0244 13.9637 14.9269 13.8662L11.0608 10.0002Z"
  }),
  svgElements: ["path"]
}),
    s = exports.b = _chunkOX4QNVYYjs.c.call(void 0, {
  name: "CloseIconMedium",
  size: "Medium",
  svg: _jsxruntime.jsx.call(void 0, "path", {
    d: "M16.6973 15.0002L21.8255 9.87209L22.883 8.81456C23.039 8.65855 23.039 8.40504 22.883 8.24904L21.7515 7.1175C21.5955 6.9615 21.3419 6.9615 21.1859 7.1175L15.0002 13.3032L8.81456 7.117C8.65855 6.961 8.40504 6.961 8.24904 7.117L7.117 8.24854C6.961 8.40454 6.961 8.65805 7.117 8.81406L13.3032 15.0002L7.117 21.1859C6.961 21.3419 6.961 21.5955 7.117 21.7515L8.24854 22.883C8.40454 23.039 8.65805 23.039 8.81406 22.883L15.0002 16.6973L20.1284 21.8255L21.1859 22.883C21.3419 23.039 21.5955 23.039 21.7515 22.883L22.883 21.7515C23.039 21.5955 23.039 21.3419 22.883 21.1859L16.6973 15.0002Z"
  }),
  svgElements: ["path"]
});

exports.a = e;
exports.b = s;